import addToCartGetters from "./getters/addToCartGetters.mjs";
import baseGetters from "./getters/baseGetters.mjs";
import belowTheFoldGetters from "./getters/belowTheFoldGetters.mjs";
import buyBoxGetters from "./getters/buyBoxGetters.mjs";
import constructorTrackingGetters from "./getters/constructorTrackingGetters.mjs";
import mediaCenterGetters from "./getters/mediaCenterGetters.mjs";
import productPageGetters from "./getters/productPageGetters.mjs";
import productHeaderGetters from "./getters/productHeaderGetters.mjs";
import fulfillmentGetters from "./getters/fulfillmentGetters.mjs";
import testGetters from "./getters/testGetters.mjs";
const getters = {
  ...addToCartGetters,
  ...baseGetters,
  ...belowTheFoldGetters,
  ...buyBoxGetters,
  ...constructorTrackingGetters,
  ...mediaCenterGetters,
  ...productPageGetters,
  ...productHeaderGetters,
  ...fulfillmentGetters,
  ...testGetters
};
export {
  getters as default
};
//# sourceMappingURL=getters.mjs.map
